"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pinoLoggingRoute = void 0;
const logger_1 = require("./logger");
const validLogLevels = {
    error: 'error',
    debug: 'debug',
    fatal: 'fatal',
    info: 'info',
    trace: 'trace',
    silent: 'silent',
    warn: 'warn',
};
function isValidLoggingLabel(label) {
    return typeof label === 'string' && label in validLogLevels;
}
const pinoLoggingRoute = (req, res) => {
    var _a, _b, _c, _d;
    if (req.method !== 'POST') {
        res.status(405).json({ error: 'Method Not Allowed' });
        return;
    }
    const { level, ts } = req.body;
    const label = level.label;
    if (!isValidLoggingLabel(label)) {
        res.status(400).json({
            error: `Invalid label ${label}`,
        });
        return;
    }
    const messages = req.body.messages;
    const bindings = (_c = (_b = (_a = req.body) === null || _a === void 0 ? void 0 : _a.bindings) === null || _b === void 0 ? void 0 : _b[0]) !== null && _c !== void 0 ? _c : {};
    logger_1.logger
        .child(Object.assign(Object.assign({}, bindings), { x_timestamp: ts, x_isFrontend: true, x_userAgent: req.headers['user-agent'], x_request_id: (_d = req.headers['x-request-id']) !== null && _d !== void 0 ? _d : 'not-set' }))[label](...messages);
    res.status(200).json({ ok: `ok` });
};
exports.pinoLoggingRoute = pinoLoggingRoute;
